import type { ChangeEvent, RefObject } from 'react';

interface FileInputProps {
  accept: string;
  ariaLabel: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  fileRef: RefObject<HTMLInputElement | null> | undefined;
  disabled?: boolean;
  id?: string;
  multiple?: boolean;
  dataTestId?: string;
}

/**
 * A basic file input component that is hidden and only accessible via a
 * parent component's button or label.
 *
 * Enforces mandatory file type accept and aria-label
 */
export function BaseFileInput({
  accept,
  ariaLabel,
  onChange,
  fileRef,
  disabled,
  id,
  multiple,
  dataTestId,
}: FileInputProps) {
  let normalizedAccept = accept;

  if (normalizedAccept.includes('image/*')) {
    normalizedAccept += ',image/heic,image/heif';
  }

  if (normalizedAccept.includes('application/*')) {
    normalizedAccept += ',application/pdf,application/xlsx,application/xls,text/csv';
  }

  return (
    <input
      id={id}
      type="file"
      accept={normalizedAccept}
      multiple={multiple}
      hidden
      onChange={onChange}
      ref={fileRef}
      aria-label={ariaLabel}
      disabled={disabled}
      data-testid={dataTestId}
    />
  );
}
